// Import the page styles
import './index.css';

import { isHTMLLinkElement, isMobile, isAndroid } from '~/assets/scripts/utils';

const HTML_ID_MOBILE = 'mobile';
const HTML_ID_PC = 'pc';
const HTML_ID_BUTTON_OPEN = 'button-open';
const HTML_ID_BUTTON_INSTALL = 'button-install';

const URL_STORE_ANDOROID = 'https://link.jp.mercari.com/70tO/ro1k0itu';
const URL_STORE_IOS = 'https://link.jp.mercari.com/70tO/xxg8yzk5';
const URL_CUSTOM_SCHEME = 'mercari://app/merpay/transfer/receive';

const device = {
  isAndroid: isAndroid(),
  isMobile: isMobile(),
};

function bootstrap(): void {
  // Render the content
  const target = document.getElementById(
    device.isMobile ? HTML_ID_MOBILE : HTML_ID_PC,
  );
  if (target) {
    target.style.display = 'block';
  }

  if (!device.isMobile) {
    return;
  }

  // Set up buttons
  const buttonOpen = document.getElementById(HTML_ID_BUTTON_OPEN);
  if (isHTMLLinkElement(buttonOpen)) {
    const params = new URLSearchParams(document.location.search.substring(1));
    buttonOpen.href = `${URL_CUSTOM_SCHEME}?token=${encodeURIComponent(
      params.get('token') || '',
    )}`;
    buttonOpen.onclick = (): void =>
      gtag('event', 'click', {
        event_category: 'open_app',
      });
  }

  const buttonInstall = document.getElementById(HTML_ID_BUTTON_INSTALL);
  if (isHTMLLinkElement(buttonInstall)) {
    buttonInstall.href = device.isAndroid ? URL_STORE_ANDOROID : URL_STORE_IOS;
    buttonInstall.onclick = (): void =>
      gtag('event', 'click', {
        event_category: 'install_app',
      });
  }
}

// Check if the DOMContentLoaded has already been completed
if (document.readyState !== 'loading') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
